import {AxiosStatic} from "axios";
import http from "@/utils/httpRequest";

/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (rule,value,callback) {
  if (value === '') {
    callback(new Error('邮箱不能为空'))
  } else if (!/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(value)) {
    callback(new Error('手机号格式错误'))
  } else {
    callback()
  }
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (rule,value,callback) {

  if (value === '') {
    callback(new Error('手机号不能为空'))
  } else if (!/^1[1-9][0-9]{9}$/.test(value)) {
    callback(new Error('手机号格式错误'))
  } else {
    callback()
  }
}
export function validatorItemCode(rule, value, callback){
  debugger
  let reg = /^[ABC]\d{8}$/;
  if (value == "") {
    callback(new Error("请填写品目编码"));
  } else if (reg.test(value)) {
    callback();
  } else {
    callback(new Error("品目编码格式不正确，格式为1位大写字母【A/B/C】+8位数字"));
  }
}
/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (rule,value,callback) {
  if (value === '') {
    callback(new Error('电话号码不能为空'))
  } else if (!/^([0-9]{3,4}-)?[0-9]{7,8}$/.test(value)) {
    callback(new Error('电话号码格式错误'))
  } else {
    callback()
  }
}

/**
 * 身份证号码
 * @param {*} s
 */
export function isIdcard (rule,value,callback) {
  let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  let _IDre15 =  /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
  // 校验身份证：
  if( _IDRe18.test( value ) || _IDre15.test( value )  ) {
    callback();
  } else {
    new callback(new Error("身份证号码不正确。"))
  }
}




/**
 * 电话号码
 * @param {*} s
 */
export function isRegPhoneNumber (rule,value,callback) {
  if(!value){
    return new callback(new Error("联系方式不能为空"))
  }
  const rsCheck =   /^1[1-9][0-9]{9}$/.test(value) || /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(value)

  setTimeout(() => {
    if (rsCheck) {
      callback();
    } else {
      callback(new Error('请输入正确的联系方式'));
    }
  }, 0);


}


/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}


export function validateDate (rule, value, callback) {
  if (Array.isArray(value)) { //格式为：daterange、datetimerange检测
    value.map(function (item) {
      if (item === "") {
        return callback("日期不能为空")
      }
    })
  } else { //格式为：date、datetime、year、month 检测
    if (value === '') {
      return callback("日期不能为空")
    }
  }
  return callback()

}

/**
 *  整数校验 只做整数检验，不做空校验
 */
export function isInteger(rule,value,callback){
  if (!value) {
    callback();
  } else {
    const re = /^\d{1,10}$/;
    const rsCheck = re.test(value);
    if (!rsCheck) {
      callback(new Error('数字格式不正确'));
    } else {
      callback();
    }
  }
}



/**
 * 1-20个字符
 */
export function strLength_1(rule,value,callback) {
  if(!value){
    return new callback(new Error("不能为空"))
  }
  setTimeout(() => {
      const re = /^.{1,20}$/;
      const rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('长度必须在1到20个字符之间'));
      } else {
        callback();
      }

  }, 0);
}


/**
 * 1-10个字符
 */
export function strLength_2(rule,value,callback) {
  if(!value){
    return new callback(new Error("不能为空"))
  }
  setTimeout(() => {
    const re = /^.{1,10}$/;
    const rsCheck = re.test(value);
    if (!rsCheck) {
      callback(new Error('长度必须在1到10个字符之间'));
    } else {
      callback();
    }

  }, 0);
}

/**
 * 1-30个字符
 */
export function strLength_3(rule,value,callback) {
  if(!value){
    return new callback(new Error("不能为空"))
  }
  setTimeout(() => {
    const re = /^.{1,30}$/;
    const rsCheck = re.test(value);
    if (!rsCheck) {
      callback(new Error('长度必须在1到30个字符之间'));
    } else {
      callback();
    }

  }, 0);
}


/**
 * 1-200个字符
 */
export function strLength_4(rule,value,callback) {
  if(!value){
    return new callback(new Error("不能为空"))
  }
  setTimeout(() => {
    const re = /^.{1,200}$/;
    const rsCheck = re.test(value);
    if (!rsCheck) {
      callback(new Error('长度必须在1到200个字符之间'));
    } else {
      callback();
    }

  }, 0);
}


/**
 * 1-50个字符
 */
export function strLength_5(rule,value,callback) {
  if(!value){
    return new callback(new Error("不能为空"))
  }
  setTimeout(() => {
    const re = /^.{1,50}$/;
    const rsCheck = re.test(value);
    if (!rsCheck) {
      callback(new Error('长度必须在1到50个字符之间'));
    } else {
      callback();
    }

  }, 0);
}


/**
 * 1-255个字符
 */
export function strLength_6(rule,value,callback) {
  if(!value){
    return new callback(new Error("不能为空"))
  }
  setTimeout(() => {
    const re = /^.{1,255}$/;
    const rsCheck = re.test(value);
    if (!rsCheck) {
      callback(new Error('长度必须在1到255个字符之间'));
    } else {
      callback();
    }

  }, 0);
}


/**
 * 1-100个字符
 */
export function strLength_7(rule,value,callback) {
  if(!value){
    return new callback(new Error("不能为空"))
  }
  setTimeout(() => {
    const re = /^.{1,100}$/;
    const rsCheck = re.test(value);
    if (!rsCheck) {
      callback(new Error('长度必须在1到100个字符之间'));
    } else {
      callback();
    }

  }, 0);
}


/**
 * 1-4个字符
 */
export function strLength_8(rule,value,callback) {
  if(!value){
    return new callback(new Error("不能为空"))
  }
  setTimeout(() => {
    const re = /^.{1,4}$/;
    const rsCheck = re.test(value);
    if (!rsCheck) {
      callback(new Error('长度必须在1到4个字符之间'));
    } else {
      callback();
    }

  }, 0);
}